module.exports = __webpack_public_path__ + "static/img/C (34).2a59d8aa.png";